import React, {useEffect, useState} from "react";
import {NavLink} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
  // faChartSimple, faBox, faHouseSignal, faUserTag, faGear, faCircleRadiation, faTowerCell,
  faG, faKey, faRightFromBracket
} from '@fortawesome/free-solid-svg-icons';
import "./header.scss";
import {Col, Navbar, Row} from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import {postLogout} from "../../api/apiClient";
import SeoulSymbol from "../../data/seoul-symbol.png";
import Container from "react-bootstrap/Container";
// import {useNavigate} from 'react-router-dom';
import PwResetModal from "./PwResetModal";
import HeaderItem from "./HeaderItem";


const Header = ({
                  propMenus = undefined,
                  propActiveMenu = undefined,
                  // propSubMenus = undefined
                }) => {

  useEffect(() => {
    // console.log(propMenus);
  }, [propMenus]);

  useEffect(() => {
    console.log(propActiveMenu);
  }, [propActiveMenu]);

  const prefix = 'ui';

  if (window.location.pathname === `/${prefix}/login`) return null;
  if (window.location.pathname === `/${prefix}/reset-pw`) return null;
  if (window.location.pathname === `/${prefix}/dash`) return null;


  const onClickLogout = (e) => {
    e.preventDefault();

    postLogout().then((res) => {
      // console.log(res.data);
      if (res.data.status === 200 && res.data.success) {
        // console.log("go login");
        // navigate(`/ui/login`);
        // navigate(`/`);
        sessionStorage.removeItem('ACCESS_TOKEN');
        window.location = '/';
      }
    });
  };


  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [modalShow, setModalShow] = useState(false);

  return (
      <>
        <Navbar expand="lg" className={"header p-0"}>
          <Container fluid>
            <Navbar.Brand href="/ui/dash_platform" className={""}>
              <Row>
                <Col md={3}>
                  <img src={SeoulSymbol} alt={"서울시"} className={"logo-img mx-3"}/>
                </Col>
                <Col md={9} className={"nav-title text-white"}>
                  <p className={"m-0"}>서울특별시</p>
                  <p className={"m-0"}>화재 안전관리 플랫폼</p>
                </Col>
              </Row>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll"/>
            <Navbar.Collapse id="navbarScroll">
              <Nav
                  className="me-auto my-2 my-lg-0"
                  navbarScroll
              >
                {/*<Nav.Link to="/ui/dash_platform" href="/ui/dash_platform"
                          className={propActiveMenu === 'dashboard' ? 'nav-link active mt-2 fw-bold' : 'nav-link py-3 mx-1'}>
                  <FontAwesomeIcon icon={faChartSimple} className={'pe-2'}/>대시보드
                </Nav.Link>*/}

                {Array.isArray(propMenus) ? propMenus.map((item, index) => {
                  return (
                      <HeaderItem
                          key={index}
                          propActiveMenu={propActiveMenu}
                          propTitle={item.menu_nm}
                          propPath={item.URI}
                          // propActiveMenu={propActiveMenu}
                          // propPath={propSubMenus[index]?.URI}
                          // propIcon={faChartSimple}
                      />
                  );
                }) : null}

              </Nav>

              <Nav className={'top-menu'}>
                <NavLink to='/ui/broker-server' className={"me-3 fs-5 nav-link"}>
                  <FontAwesomeIcon icon={faG}/>
                </NavLink>
                <span
                    className={"me-3 fs-5 nav-link"}
                    onClick={() => {
                      setModalShow(true);
                    }}
                >
                <FontAwesomeIcon icon={faKey}/>
              </span>
                <NavLink onClick={onClickLogout} className={"fs-5 nav-link"} to={"/"}>
                  <FontAwesomeIcon icon={faRightFromBracket}/>
                </NavLink>
              </Nav>

            </Navbar.Collapse>
          </Container>
        </Navbar>

        <PwResetModal
            show={modalShow}
            onHide={() => setModalShow(false)}
        />
      </>
  )
}

export default Header;